import React, { useCallback } from 'react';
import { CreatePasswordModal } from '@simplybenefits/sb-ui-library';
import { createPassword as createPasswordAdmin } from '../../actions/admin.js';
import { createPassword as createPasswordAdvisor } from '../../actions/advisor.js';
import { connect } from 'react-redux';

/**
 *
 * @param close
 * @param dispatch
 * @returns {Element}
 * @constructor
 */
function CreatePassword({
    hideModal,
    isAdvisor,
    dispatch
}) {

    /**
     *
     * @param password
     * @returns {Promise<void>}
     */
    const submit = useCallback(async (password) => {
        const fn = isAdvisor ? createPasswordAdvisor : createPasswordAdmin;
        const result = await dispatch(fn(password));

        if (result) {
            window.location.reload();
        }
    }, [ isAdvisor, dispatch ]);

    return (
        <CreatePasswordModal
            open={true}
            close={hideModal}
            submit={(...params) => submit(...params)}
        />
    );
}

/**
 *
 * @param state
 * @returns {{loader}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default connect(mapStateToProps)(CreatePassword);